// extracted by mini-css-extract-plugin
module.exports = {"popUp":"Popup_popUp__1CLCB","img":"Popup_img__3BLM3","text":"Popup_text__2uaXi","cross":"Popup_cross__1qYKK"};